module.exports = __webpack_public_path__ + "static/media/DW5110.de3520bf.png";